import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const deleteParty = (state) => {

  return axios.get(API + "parties/party-inactive/"+state+"/",{headers: authHeader(),});
};

const PartyPermanentDelete = (state) => {

  return axios.delete(API + "parties/party-delete/"+state+"/",{headers: authHeader(),});
};
const DeletePartyService = {
    deleteParty,
    PartyPermanentDelete
  };
  export default DeletePartyService;